export default defineNuxtRouteMiddleware(async () => {
  const { checkForAuth } = useAuthStore();
  // middleware doesn't send cookies on first load so get refresh token here and pass
  const refreshToken = useCookie('user_refresh_token') || null;
  if (!refreshToken.value) {
    return navigateTo('/');
  }

  const isAuth = await checkForAuth(refreshToken.value);

  if (!isAuth) {
    return navigateTo('/');
  }
});
